import { useEffect } from 'react'
import useScript from './useScript'
/*
 * @param {string} gsource - the source of the swf
 * @param {string} Rufflecontainer - the container that the player will be stored in
 * @param {number} width - the width of the ruffle player
 * @param {number} height - the height of the ruffle player
 */

// Declaring width and height for the player isnt reccomeded
// because it will automatically take 100% of your ruffleContainer
// But feel free to set the width if you would like to

const useRuffle = (Rufflecontainer, gsource, width = '100%', height = '100%') => {
  if (!Rufflecontainer) throw new Error('Rufflecontainer is required')
  useScript('/ruffle/ruffle.js')

  useEffect(() => {
    const getTheme = () => (document.documentElement.classList.contains('dark') ? 'dark' : 'light')
    const getBackgroundColor = () => (getTheme() === 'dark' ? '#1A202C' : '#FFFFFF')

    const applyBackgroundColor = (playerEl) => {
      const color = getBackgroundColor()
      if (window.RufflePlayer && window.RufflePlayer.config) {
        window.RufflePlayer.config = {
          ...window.RufflePlayer.config,
          backgroundColor: color,
        }
      }
      if (playerEl) {
        playerEl.style.backgroundColor = color
      }
      if (Rufflecontainer.current) {
        Rufflecontainer.current.style.backgroundColor = color
      }
    }

    window.RufflePlayer = window.RufflePlayer || {}
    window.RufflePlayer.config = {
      autoplay: 'auto',
      unmuteOverlay: 'visible',
      letterbox: 'fullscreen',
      warnOnUnsupportedContent: true,
      contextMenu: 'rightClickOnly',
      showSwfDownload: false,
      upgradeToHttps: window.location.protocol === 'https:',
      maxExecutionDuration: 15,
      logLevel: 'error',
      base: null,
      menu: true,
      salign: '',
      scale: 'showAll',
      quality: 'high',
      splashScreen: false,
      backgroundColor: getBackgroundColor(),
    }

    let isMounted = true
    let currentPlayer = null
    let mutationObserver = null

    const initializeRufflePlayer = () => {
      if (!isMounted) return
      if (window.RufflePlayer && typeof window.RufflePlayer.newest === 'function') {
        // Clear any existing player(s) to avoid duplicates in StrictMode
        if (Rufflecontainer.current) {
          while (Rufflecontainer.current.firstChild) {
            Rufflecontainer.current.removeChild(Rufflecontainer.current.firstChild)
          }
        }
        const ruffle = window.RufflePlayer.newest()
        const player = ruffle.createPlayer()
        currentPlayer = player
        if (Rufflecontainer.current) {
          Rufflecontainer.current.appendChild(player)
        }
        player.style.width = width
        player.style.height = height
        applyBackgroundColor(player)
        player
          .load(gsource, {
            allowScriptAccess: false,
          })
          .then(() => {
            console.log('swf loaded')
          })
          .catch(error => {
            console.log('swf load error:', error)
          })
      } else {
        setTimeout(initializeRufflePlayer, 100)
      }
    }

    if (typeof MutationObserver !== 'undefined') {
      mutationObserver = new MutationObserver(() => applyBackgroundColor(currentPlayer))
      mutationObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] })
    }

    let addedLoadListener = false
    if (document.readyState === 'complete') {
      initializeRufflePlayer()
    } else {
      window.addEventListener('load', initializeRufflePlayer)
      addedLoadListener = true
    }

    return () => {
      isMounted = false
      if (addedLoadListener) {
        window.removeEventListener('load', initializeRufflePlayer)
      }
      if (mutationObserver) {
        mutationObserver.disconnect()
      }
      if (currentPlayer && currentPlayer.remove) {
        try {
          currentPlayer.remove()
        } catch (_) {}
      }
      if (Rufflecontainer.current) {
        while (Rufflecontainer.current.firstChild) {
          Rufflecontainer.current.removeChild(Rufflecontainer.current.firstChild)
        }
      }
    }
  }, [Rufflecontainer, gsource, width, height])
}

export default useRuffle
